import React from 'react';
import { withRouter } from 'react-router';
import { Event } from './EventPage';
const NewEventPage = () => <Event />;
export default withRouter(NewEventPage);
